<template>
    <div
        class="tooltip relative inline-block cursor-pointer z-9"
        @mouseenter="handleOnHover"
        @mouseleave="open = false"
    >
        <button
            class="block focus:outline-none"
            aria-haspopup="true"
            :aria-expanded="open"
            @focus="open = true"
            @focusout="open = false"
            @click.prevent
        >
            <i :class="`fa-regular ${icon} ml-1`"></i>
        </button>
        <div
            class="z-10 absolute bottom-2/3 transform transition-all"
            :class="{
                '-translate-x-1/2 left-1/2': placement === 'center',
                'right-0': placement === 'left',
            }"
        >
            <transition name="fadeInOut">
                <div
                    class="min-w-44 p-2 rounded shadow-lg overflow-hidden mb-2 bg-[#1c293d] text-white"
                    v-show="open"
                    v-cloak
                >
                    <div class="text-xs whitespace-normal text-center">
                        {{ text }}
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: String,
        placement: {
            type: String,
            default: 'center',
        },
        icon: {
            type: String,
            default: 'fa-circle-exclamation',
        },
    },
    data: () => ({
        open: false,
    }),
    directives: {},
    methods: {
        handleOnHover() {
            this.open = true;
        },
    },
    created() {},
    mounted() {},
};
</script>
<style lang="scss" scoped>
.fadeInOut-enter-active,
.fadeInOut-leave-active {
    transition: opacity 0.8s;
    opacity: 1;
}
.fadeInOut-enter,
.fadeInOut-leave-to {
    opacity: 0;
}
</style>
